import { inject, Injectable } from '@angular/core';
import { DashboardLabelsFacade } from '@cpm-pr1618003/ng-initializer-lib';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import * as actions from '../actions/init.actions';
import { InitService } from '../init.service';
import { AccountInfo } from '../state/init.state';
import { UserManagementFacade } from '../user-management/facade/user-management.facade';

@Injectable({
  providedIn: 'root',
})
export class InitEffects {
  private readonly userManagementFacade = inject(UserManagementFacade);
  private readonly initService = inject(InitService);
  private readonly dashboardLabelsFacade = inject(DashboardLabelsFacade);
  private readonly actions$ = inject(Actions);

  getUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getUser),
      switchMap((action) => {
        return this.initService.getUser(action.userId).pipe(
          //  delay(1000),
          map((accountInfo: AccountInfo) => {
            return actions.getUserSuccess({ accountInfo });
          }),
          catchError(() => of(actions.getUserError())),
        );
      }),
    ),
  );

  getUserSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.getUserSuccess),
        tap(() => {
          this.dashboardLabelsFacade.getDisplayLabels();
          this.userManagementFacade.getContacts();
          this.userManagementFacade.getMessages();
          this.userManagementFacade.getNotifications();
        }),
      ),
    { dispatch: false },
  );
}
